const styles = ({ typography }) => ({
  container: {
    "padding": `${typography.pxToRem(32)} 0`,
  },
});

export default styles;
